var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayTightIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_197_135368",
    maskUnits: "userSpaceOnUse",
    x: 4.83337,
    y: 1.5,
    width: 14,
    height: 17,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.83337,
    y: 1.5,
    width: 14,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4064 10.09L14.8685 10.4397L15.4121 10.0936L15.4064 10.09ZM5.83337 17.6917V2.5L17.7693 10.0936L5.83337 17.6917Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4064 10.09L14.8685 10.4397L15.4121 10.0936L15.4064 10.09ZM5.83337 17.6917V2.5L17.7693 10.0936L5.83337 17.6917Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4064 10.09L15.5675 9.83689L15.4047 9.73334L15.2429 9.83848L15.4064 10.09ZM14.8685 10.4397L14.705 10.1881L15.0296 10.6928L14.8685 10.4397ZM15.4121 10.0936L15.5732 10.3467L15.9709 10.0935L15.5731 9.8405L15.4121 10.0936ZM5.83337 2.5L5.99441 2.24688L5.53337 1.95357V2.5H5.83337ZM5.83337 17.6917H5.53337V18.2383L5.99447 17.9447L5.83337 17.6917ZM17.7693 10.0936L17.9304 10.3467L18.3281 10.0935L17.9303 9.8405L17.7693 10.0936ZM15.4064 10.09L15.2429 9.83848L14.705 10.1881L14.8685 10.4397L15.032 10.6912L15.5699 10.3415L15.4064 10.09ZM15.4121 10.0936L15.251 9.84055L14.7074 10.1866L14.8685 10.4397L15.0296 10.6928L15.5732 10.3467L15.4121 10.0936ZM15.4064 10.09L15.2454 10.3431L15.2511 10.3467L15.4121 10.0936L15.5731 9.8405L15.5675 9.83689L15.4064 10.09ZM5.83337 2.5H5.53337V17.6917H5.83337H6.13337V2.5H5.83337ZM17.7693 10.0936L17.9303 9.8405L5.99441 2.24688L5.83337 2.5L5.67234 2.75312L17.6082 10.3467L17.7693 10.0936ZM5.83337 17.6917L5.99447 17.9447L17.9304 10.3467L17.7693 10.0936L17.6082 9.84054L5.67227 17.4386L5.83337 17.6917Z",
    fill: "currentColor",
    mask: "url(#path-1-outside-1_197_135368)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayTightIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Play_Tight_Icon.6242d2929e67628f331e5ede92496b20.svg";